<template>
	<div>
		<div class="card-grid">
			<!-- only show important dates for refi -->
			<div v-if="loanDetails.loan.productType === 2">
				<ImportantDatesCard :keyDates="loanDetails.filteredKeyDates" />
			</div>

			<ServicerInterestDetailsCard :loanDetails="loanDetails" />
			<LoanProgramDetailsCard :loanDetails="loanDetails" />
			<ServicerDetailsCard :loanDetails="loanDetails" @updateLoan="onUpdateLoan" />
		</div>
	</div>
</template>

<script setup lang="ts">
	import '@/assets/css/card.css';
	import { defineProps } from 'vue';
	import { LoanDetails } from '@/models/loans';
	import ServicerInterestDetailsCard from '../loc/ServicerInterestDetailsCard.vue';
	import LoanProgramDetailsCard from '../loc/LoanProgramDetailsCard.vue';
	import ServicerDetailsCard from '../loc/ServicerDetailsCard.vue';
	import ImportantDatesCard from '../loc/ImportantDatesCard.vue';

	defineProps<{
		loanDetails: LoanDetails;
		onUpdateLoan: () => Promise<void>;
	}>();
</script>
